import Vue from "vue";
import { Component } from "vue-property-decorator";

import { SelectOption } from "../../../../logic/types";
import { UserActivationActionTypeEnum } from "./index";

@Component({})
export class ActivationActionMixin extends Vue {
  get baseActionOptions(): Array<SelectOption> {
    return [
      {
        label: this.$t('bot_feedback_activation_action_data_option_message').toString(),
        value: UserActivationActionTypeEnum.Message
      },
      {
        label: this.$t('bot_feedback_activation_action_data_option_flow').toString(),
        value: UserActivationActionTypeEnum.Flow
      },
    ]
  }
}
